import { RefObject } from 'react';
import html2canvas from 'html2canvas';

export const captureView = async (viewRef: RefObject<HTMLElement>) => {
  const canvas = await html2canvas(viewRef.current!);
  return canvas.toDataURL('image/jpeg', 1);
};
